import React, { useState, useEffect } from 'react';
import { users } from '../api';

function Users({ user }) {
  const [usersList, setUsersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ username: '', role: 'user' });

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const response = await users.getAll();
      setUsersList(response.data);
    } catch (error) {
      console.error('Error loading users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await users.create(formData);
      alert(`User created! Temp password: ${response.data.tempPassword}`);
      setShowModal(false);
      setFormData({ username: '', role: 'user' });
      loadUsers();
    } catch (error) {
      alert('Error creating user');
    }
  };

  const handleResetPassword = async (u) => {
    if (!window.confirm(`Reset the password for ${u.username}?\n\nTheir current password will stop working immediately and they will be required to set a new one at next login.`)) {
      return;
    }
    try {
      const response = await users.resetPassword(u.id);
      window.prompt(
        `Password reset for ${response.data.username}.\n\nGive them this temporary password. They will be asked to choose a new one when they log in.`,
        response.data.tempPassword
      );
    } catch (error) {
      alert('Error resetting password');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this user?')) {
      try {
        await users.delete(id);
        loadUsers();
      } catch (error) {
        alert('Error deleting user');
      }
    }
  };

  if (user?.role !== 'admin') {
    return <div className="card">You don't have permission to view this page.</div>;
  }

  if (loading) return <div className="spinner"></div>;

  return (
    <div>
      <div className="page-header flex-between">
        <div>
          <h1 className="page-title">Users</h1>
          <p className="page-subtitle">Manage system users</p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          + Add User
        </button>
      </div>

      {/* Permissions Reference */}
      <div className="grid grid-2 mb-4">
        <div className="card">
          <h3 className="card-title">Admin Permissions</h3>
          <ul style={{marginLeft: '20px', lineHeight: '1.8'}}>
            <li>Full system access</li>
            <li>Create, edit, and delete positions</li>
            <li>View, edit, and move applicants</li>
            <li>Edit applicant contact information</li>
            <li>Mark viewed/interviewed, add notes</li>
            <li>View metrics and analytics</li>
            <li><strong>Manage users</strong></li>
          </ul>
        </div>
        
        <div className="card">
          <h3 className="card-title">User Permissions</h3>
          <ul style={{marginLeft: '20px', lineHeight: '1.8'}}>
            <li>Same as Admin permissions</li>
            <li><strong>Except: Cannot manage users</strong></li>
          </ul>
        </div>
      </div>

      <div className="card">
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Role</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {usersList.map(u => (
                <tr key={u.id}>
                  <td><strong>{u.username}</strong></td>
                  <td>
                    <span className={`badge ${u.role === 'admin' ? 'badge-primary' : 'badge-secondary'}`}>
                      {u.role}
                    </span>
                  </td>
                  <td>{new Date(u.created_at).toLocaleDateString()}</td>
                  <td>
                    <div className="flex gap-1">
                      <button
                        className="btn btn-sm btn-outline"
                        onClick={() => handleResetPassword(u)}
                      >
                        Reset Password
                      </button>
                      {u.id !== user.id && (
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(u.id)}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3 className="modal-title">Add User</h3>
              <button onClick={() => setShowModal(false)}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Username *</label>
                  <input
                    type="text"
                    className="form-input"
                    value={formData.username}
                    onChange={e => setFormData({...formData, username: e.target.value})}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Role</label>
                  <select
                    className="form-select"
                    value={formData.role}
                    onChange={e => setFormData({...formData, role: e.target.value})}
                  >
                    <option value="user">User</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
                <p className="text-secondary">A temporary password will be generated and displayed.</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">Create</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Users;
